/**
 * 税收缴款退款操作
 */

import React, { Component } from 'react';
import { Modal, Radio, Row, Descriptions, Divider } from 'antd';

import http from '../../../axios/http';

import messager from '../../ui/messager';


import { fixedNumber } from '../../../util/util';


const pay_type = { "trade_tax": "买卖双方交易税", "trade_tax_seller": "卖家交易税", "trade_tax_buyer": "买家交易税" };

class TaxPayRefund extends Component {

    state = {
        radioVal: null
    }

    save = () => {
        let orderId = this.state.radioVal;
        if (orderId == null || orderId === "") {
            messager.notify("请选择要退款的订单！");
            return;
        }
        http.post({
            url: '/taxTicket/createTaxRefund',
            data: {
                orderId: orderId
            },
            success: (res) => {
                messager.notify("已发起退款，请告知商户注意微信消息！");
                this.props.onCancel();
            }
        });
    }

    radioChange = (e) => {
        this.setState({ radioVal: e.target.value });
    }

    render() {
        const { visible, onCancel, list, data } = this.props;
        const spanStyle = {
            display: 'inline-block',
            height: '30px',
            lineHeight: '30px',
            width: '150px',

        };
        return (
            <Modal
                visible={visible}
                title="税收缴款退款"
                okText="退款"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.setState({ radioVal: null }) }}
            >
                <Descriptions bordered column={2}>
                    <Descriptions.Item label="车架号">{data.vin}</Descriptions.Item>
                    <Descriptions.Item label="车牌号">{data.plateNo}</Descriptions.Item>
                    <Descriptions.Item label="卖方">{data.sellerName}</Descriptions.Item>
                    <Descriptions.Item label="买方">{data.buyerName}</Descriptions.Item>
                    <Descriptions.Item label="车辆价格">{data.amount}</Descriptions.Item>
                </Descriptions>
                <Divider orientation="left">已缴费订单</Divider>
                <Radio.Group onChange={this.radioChange} value={this.state.radioVal} style={{ width: '100%' }}>
                    {
                        list.map((item, index) => {
                            return (<Row key={index}>
                                <Radio value={item.orderId} key={item.id}>
                                    <span style={spanStyle}>{item.payTime}</span>
                                    <span style={spanStyle}>{pay_type[item.type]}</span>
                                    <span style={spanStyle}>{"￥"+fixedNumber(item.totalAmount / 100, 2)}</span>
                                </Radio>
                            </Row>)
                        })
                    }
                </Radio.Group>
            </Modal >
        );
    }
}

export default TaxPayRefund;